$giper_baza_flex_field $mol_view
	sub / <= Sub $mol_view
	pawn? $giper_baza_pawn
	land = pawn land
	prop $giper_baza_flex_prop
	Enum $mol_select
		enabled <= enabled true
		value? <=> enum? null
		options <= enum_options /
		option_label* <= enum_label* \
	Bool $mol_check_box
		enabled <= enabled true
		checked? <=> bool? false
	Int $mol_number
		enabled <= enabled true
		value? <=> int? +NaN
	Real $mol_number
		enabled <= enabled true
		value? <=> real? +NaN
	Ref $mol_bar sub <= link_content /
		<= Link_dump $giper_baza_unit_sand_dump
			land <= land
			value <= link_value null
		<= Link_pick $mol_select
			enabled <= enabled true
			value? <=> link? null
			options <= link_options /
			option_label* <= link_label* \
		<= Link_new $mol_select
			Filter null
			trigger_content /
				<= Link_new_icon $mol_icon_plus
			value? <=> link_new? null
			dictionary *
				local @ \💼 Local
				pull @ \📢 All pull
				post @ \✍ All post
				read @ \🔎 All read
				deny @ \🔐 Private
	Str $mol_textarea
		enabled <= enabled true
		value? <=> str? \
		selection? <=> str_selection? /
	Time $mol_date
		enabled <= enabled true
		value_moment? <=> time? $mol_time_moment
	Dict $mol_expander
		title <= dict_title \
		content / <= Dict_form $giper_baza_flex_form
			enabled <= enabled true
			pawn <= dict_pawn $giper_baza_dict
	Text $mol_textarea
		enabled <= enabled true
		value? <=> text? \
		selection? <=> text_selection? /
	List $mol_list
		rows /
			<= List_items $mol_list
				rows <= list_items /
					<= List_item*0 <= List_item_drop* $mol_drop
						adopt? <=> list_item_adopt? null
						receive? <=> list_item_receive*? null
						allow /
							\move
							\copy
						Sub <= List_item_drag* $mol_drag
							end? <=> list_item_drag_end*? null
							transfer *
								text/plain <= list_item_value* \
								text/html <= list_item_html* \
								text/uri-list <= list_item_uri* \
							Sub <= List_item_content* $mol_view sub /
								<= List_item_kill* $mol_button_minor
									clicks? <=> list_item_kill*? null
									hint \Double to remove
									sub /
										<= List_item_kill_icon* $mol_icon_close
								<= List_item_dump* $giper_baza_unit_sand_dump
									land <= land
									sand <= list_sand* $giper_baza_unit_sand
			<= List_drop $mol_drop
				adopt? <=> list_item_adopt? null
				receive? <=> list_receive? null
				allow /
					\move
					\copy
				Sub <= List_tools $mol_bar sub <= list_tools /
					<= List_pick $mol_select
						enabled <= enabled true
						value? <=> list_pick? null
						options <= link_options
						option_label* <= link_label* \
					<= List_item_add $mol_button_minor
						enabled <= enabled true
						click? <=> list_item_add? null
						title \+
					<= List_item_link $mol_string
						enabled <= enabled true
						value? <=> list_item_link_value? \
						submit? <=> list_item_link? null
						hint \Link
